import { api } from '@/lib/api'

export function downloadContractorTaxForm({
  taxFormId,
}: {
  taxFormId: string
}) {
  return api.get(`/v1/me/contractor-tax-forms/${taxFormId}`, {
    responseType: 'blob',
  })
}
